import { Injectable, Injector, Type } from '@angular/core';
import { RecordsUserPermissionService } from '@records/services/records-user-permission.service';
import { CatalogsService } from '@miq/catalog';
import { UserColloquialService } from '@shared/locale/user-colloquial.service';
import { EntityDisablerFactoryService } from '@records/services/entity-disabler.service';
import { RecordDeactivatorDialog } from '@records/services/record-deactivator-dialog.service';
import { UpdateRecordService } from '@records/controls/services/update-record.service';
import { CbreAlertService } from '@cbre/alerts';
import { DeactiveDialogService } from '@shared/services/deactivate-guard.service';

@Injectable({ providedIn: 'root' })
export class DecoratorServiceProvider {
  private static Injector: Injector | undefined = undefined;
  private static cache = new Map();

  public static setInjector(injector: Injector) {
    DecoratorServiceProvider.Injector = injector;
    // Eagerly attempt to cache a few commonly used services that actions rely on during app
    // initialization (helps when actions run during routing/resolvers early in the app lifecycle).
    const eager = [
      RecordsUserPermissionService,
      CatalogsService as any,
      UserColloquialService,
      EntityDisablerFactoryService,
      RecordDeactivatorDialog,
      UpdateRecordService,
      CbreAlertService as any,
      DeactiveDialogService,
    ];
    for (const t of eager) {
      try {
        const inst = injector.get<any>(t as any);
        DecoratorServiceProvider.cache.set(t as any, inst);
      } catch {
        // ignore services not available at startup
      }
    }
  }

  /**
   * This should be used for unit test purposes only
   */
  public static clearInjector() {
    DecoratorServiceProvider.Injector = undefined;
    DecoratorServiceProvider.cache.clear();
  }

  public static getInjector(): Injector {
    if (DecoratorServiceProvider.Injector == null) {
      throw new Error('Injector not initialized');
    }
    return DecoratorServiceProvider.Injector;
  }

  public static getInstance<T>(token: Type<T>): T {
    let result = DecoratorServiceProvider.cache.get(token);
    if (result == null) {
      try {
        result = DecoratorServiceProvider.getInjector().get<T>(token);
      } catch {
        result = undefined as any;
      }
      DecoratorServiceProvider.cache.set(token, result);
    }
    return result;
  }
}
